export var $SUCCESS_COLOR = "#27ae60";
export var $ERROR_COLOR = "#fa5555";
export var $Link_COLOR = "#2E5BFF";
export var $WARN_COLOR = "#faad14";